import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC2oONjEsmwj1LFcz9fHi2dePceAoj89Gc",
  authDomain: "kw-poznan.firebaseapp.com",
  projectId: "kw-poznan",
  storageBucket: "kw-poznan.firebasestorage.app",
  messagingSenderId: "805132794785",
  appId: "1:805132794785:web:914d775fa7928aad4f69e0"
};
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);

if(window.location.hostname==="localhost"){
  connectAuthEmulator(getAuth(),"http://localhost:9099")
  connectFirestoreEmulator(getFirestore(), 'localhost', 8080);
}
enableIndexedDbPersistence(getFirestore())
  .catch((err) => {
      console.error(err)
  });
// Initialize Firebase
